"use client";

import React from "react";
import { SupAmountInput } from "@repo/ui-widgets";

import config from "@/../config/dapp.config";
import useChainInfo from "@/hooks/useChainInfo";

const inputConfig = {
  fiatMaxDecimals: config.decimalsRoundingLimit,
  tokenMaxDecimals: config.decimalsBigRoundingLimit,
};

interface Balance {
  symbol: string;
  decimals: number;
  amount: string;
  price: number;
  icon?: string;
  logoURI?: string;
}

interface Web3PiggyAmountInputProps {
  balance: Balance;
  totalAmount: string;
  handleAmountChange: (value: string | undefined) => void;
  label?: string;
}

export default function Web3PiggyAmountInput({ balance, totalAmount, handleAmountChange, label = "FUNDING AMOUNT" }: Web3PiggyAmountInputProps) {
  const { data: chainData } = useChainInfo(8453);

  return (
    <div className="mb-6 inline-flex w-full flex-col items-start justify-start gap-1">
      {chainData && (
        <SupAmountInput
          className="w-full"
          disableFiat
          disableTokenChange
          label={label}
          value={totalAmount}
          balance={balance}
          chain={chainData}
          config={inputConfig}
          sliderMarks={25}
          onChange={handleAmountChange}
        />
      )}
    </div>
  );
}
